import { render, staticRenderFns } from "./DonutChart12.vue?vue&type=template&id=78f2980c&scoped=true"
import script from "./DonutChart12.vue?vue&type=script&lang=js"
export * from "./DonutChart12.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f2980c",
  null
  
)

export default component.exports